// extracted by mini-css-extract-plugin
export default {"content":"VideoBlock__content-YcOS","title":"VideoBlock__title-p_B2","component":"VideoBlock__component-z7Ka","row":"VideoBlock__row-PywJ","video":"VideoBlock__video-qYoc"};